__turbopack_context__.v({
  "flair": "Flair-module__QXBqVq__flair",
});
